module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform business-loan"
  }, [_c('div', {
    staticClass: "row business-loan-box american-credit-partner"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1"
  }, [_c('div', {
    staticClass: "business-loan-box-left-inner"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#ffffff",
      "color": "rgb(84, 86, 255)",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "1px solid rgb(84, 86, 255)",
      "margin": "7px"
    },
    on: {
      "click": function($event) {
        return this.window.open('https://youtu.be/JH96Q66Y4Hc', '_blank')
      }
    }
  }, [_vm._v("Watch Demo")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Team Customer Voice Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("I need to spend my time meeting customers’ expectations, not on lengthy loan applications.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("Let’s Talk")]), _vm._v(" "), _vm._m(7)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("The American "), _c('br'), _vm._v("Credit"), _c('sup', [_vm._v("®")]), _vm._v(" team")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "30px",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#696969",
      "font-weight": "400"
    }
  }, [_vm._v("Get the credit you deserve from a lender you can trust. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 business-loan-box-right"
  }, [_c('img', {
    staticClass: "american-credit-team-head-img",
    attrs: {
      "src": require("../assets/imgs/American_Credit_Team_Member.png"),
      "alt": "American Credit Team Member Jun Mao"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#053a7a"
    }
  }, [_c('div', {
    staticClass: "container bluebg text-center"
  }, [_c('br'), _vm._v(" "), _c('h1', {
    staticClass: "display-5 text-whitee text-center font-weight-bolder"
  }, [_vm._v("One fine team, one great goal")]), _vm._v(" "), _c('div', {
    staticClass: "contexbox text-center"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "h5 font-weight-bold"
  }, [_vm._v("\n            Getting you the secured business loan you need is what we’re\n            all about.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "text-whitee"
  }, [_vm._v("\n            American Credit’s team is as diverse as the small business community it serves. We bring together a wide range of skills and personalities—all dedicated to delivering equipment loans and invoice/AR financing for your business, reflecting expertise in everything from finance, security and IT to support and customer service, our team members have one focus: You.\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container whitebg text-center"
  }, [_c('div', {
    staticClass: "contexbox text-center"
  }, [_c('br'), _vm._v(" "), _c('br'), _c('a', {
    attrs: {
      "name": "team"
    }
  }, [_c('h1', {
    staticClass: "darkbluefont font-weight-bolder"
  }, [_c('a', {
    attrs: {
      "href": "/team#team"
    }
  }, [_vm._v("Meet the American Credit core team")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img-responsive center-block",
    staticStyle: {
      "box-shadow": "0 2px 5px rgba(0,0,0,.15)",
      "border-radius": "49.9%"
    },
    attrs: {
      "src": require("../assets/imgs/Jun_Mao.png"),
      "alt": "Jun Mao | American Credit"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h5 darkbluefont font-weight-bold"
  }, [_vm._v("Jun Mao")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "h5 darkbluefont font-weight-bold"
  }, [_vm._v("Senior Software Engineer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "h6 text-left"
  }, [_c('h6', {
    staticClass: "text-left"
  }, [_vm._v("\n              Jun has over 5 years’ experience in web and mobile app development. He is proficient in web server architecture, website optimization, \n              data management, deployment and operations. Jun is a fintech enthusiast and is developing American Credit's proprietary Loan Origination \n              Platform, utilizing state-of-the-art artificial intelligence and blockchain technologies.\n            ")]), _vm._v(" "), _c('br'), _vm._v("\n            Jun’s career highlights include:\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n                • Senior Software Developer at VUI AI Inc. (2 years):  Developed an artificial intelligence based voice user interface for the company’s mobile apps.\n                "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n                • Full Stack Developer at We Housing (2 years): Web app with REST API, data management, architecture, deployment, and optimization of website.\n                "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n                • Full Stack Developer at We Career (1 year): Developed web and mobile apps.\n                "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n              Education:"), _c('br'), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n                • Masters of Engineering at Syracuse University\n                "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('li', {
    staticClass: "text-left"
  }, [_vm._v("\n                • Bachelor's degree of Engineering at Beijing University of Post and Telecommunications (BUPT), China\n                "), _c('br'), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/woaij007/",
      "target": "_blank"
    }
  }, [_vm._v("Profile in LinkedIn")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Team_Customer_Voice.png"),
      "alt": "American Credit Team Customer Voice"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Laurie Townsend")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("Account Receivable Manager, Lone Star Uniform Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715249aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jun.vue
// module id = 1982
// module chunks = 5